import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  @Output() hideMenu = new EventEmitter();
  @Output() voiceSelect = new EventEmitter<string>();

  leaveMenu() {
    this.hideMenu.emit();
  }

  navigateTo(section: string) {
    this.voiceSelect.emit(section);
  }
}
